<template>
  <vue-form-generator
    :model="model"
    :schema="form.schema"
    :options="form.options"
    ref="insuranceForm"
  ></vue-form-generator>
</template>

<script>
import VueFormGenerator from 'vue-form-generator';

import SCHEMA from '@/components/my_deals/actions/insurance/resources/schema';


export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  components: {
    'vue-form-generator': VueFormGenerator.component,
  },
  data() {
    return {
      form: SCHEMA.insurance,
    };
  },
  methods: {
    validate() {
      return this.$refs.insuranceForm.validate();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/actions/insurance/InsuranceForm.vue